export class VideoLocalPreview {
    constructor(containerVideoId) {
        this.containerVideoId = containerVideoId;
    }
    onInit() {
        const containerVideo = document.getElementById(this.containerVideoId);
        if (!containerVideo)
            return console.log(`Not element fount with '${this.containerVideoId}' Id`);
        const imgPreview = containerVideo.getAttribute('srcImg');
        const VideoUrl = containerVideo.getAttribute('srcvideo');
        if (!VideoUrl)
            return console.log(`Not UrlVideo code with '${VideoUrl}' value`);
        if (!imgPreview || imgPreview == "") {
            const internalContent = `<video class="video-local" controls autoplay>
  <source src="${VideoUrl}" type="video/mp4">
  Your browser does not support the video tag.
</video>`;
            containerVideo.innerHTML = internalContent;
        }
        else {
            // Creamos la estructura interna
            const internalContent = `<div class="video-container-image">` +
                `<img class="relative z-10 w-full" src="${imgPreview}" loading="lazy" alt="landing video">` +
                `</div>` +
                `<div id=${VideoUrl}></div>`;
            containerVideo.innerHTML = internalContent;
            // Agregamos el evento click de la imagen
            const myImage = containerVideo.querySelector('div.video-container-image');
            myImage && this.clickPosterVideo(myImage, containerVideo, VideoUrl);
        }
    }
    clickPosterVideo(imageReference, containerVideo, urlVideo) {
        const landingPosterVideo = imageReference;
        landingPosterVideo && landingPosterVideo.addEventListener('click', () => {
            var _a;
            landingPosterVideo.style.opacity = '0';
            (_a = containerVideo.parentElement) === null || _a === void 0 ? void 0 : _a.classList.add("played");
            this.onVideo(containerVideo, urlVideo);
        });
    }
    onVideo(containerVideo, urlVideo) {
        var _a;
        const internalContent = `<video class="video-local" controls autoplay>
  <source src="${urlVideo}" type="video/mp4">
  Your browser does not support the video tag.
</video>`;
        containerVideo.innerHTML = internalContent;
        (_a = containerVideo.querySelector("video")) === null || _a === void 0 ? void 0 : _a.play();
    }
}
